import './global.css';

export const shouldUpdateScroll = () => {
  return false;
};
